import { render, staticRenderFns } from "./WYSIWYG.vue?vue&type=template&id=cdd0ef36"
import script from "./WYSIWYG.vue?vue&type=script&lang=js"
export * from "./WYSIWYG.vue?vue&type=script&lang=js"
import style0 from "./WYSIWYG.vue?vue&type=style&index=0&id=cdd0ef36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports